// extracted by mini-css-extract-plugin
module.exports = {"otpContainer":"mfaBackupForm_otpContainer__1FULv","backupInput":"mfaBackupForm_backupInput__2djI2"};